module.exports = __webpack_public_path__ + "img/img-c33007da.97252238.png";